import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table";
import { Input } from "../ui/input";
import { ListFilter, Search } from "lucide-react";
import { Button } from "../../component/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { EllipsisVertical } from 'lucide-react';
import { deleteDistributor, deleteEmployee, deleteInvestor, getDistributorInfo, getEmployeeInfo, getInvestorInfo,  } from '../../utils/util';
import CreateInvestor from '../userManagement/investor/createInvestor';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setDistributorInfo } from '../../context/actions/distributorInfoAction';
import { loaderSet } from "../../context/actions/loaderAction";
import { setInvestorInfo } from '../../context/actions/investorInfoAction';
import { setEmployeeInfo } from '../../context/actions/employeeInfoAction';
import { alertDanger, alertSuccess } from '../../context/actions/toastAction';
import { Dialog, DialogContent, DialogDescription, DialogOverlay, DialogTitle } from '@radix-ui/react-dialog'
import Loader from '../loader';
import DeleteConfirmationDialog from '../ui/deleteConfirmationDialog';
import DialogBox from '../ui/deleteConfirmationDialog';


const Datatable3 = ({ onRowClick = () => {},getAllInvestor,getAllDistributor,getAllEmployee,totalPage,currentPage,setCurrentPage,data=[], buttonOptions,user_type ,columns,isEmployeeLoggedIn=false}) => {
 const [isOpenDeleteUserConfirmation,setIsOpenDeleteUserConfirmation]=useState(false)
 const [selectedItem, setSelectedItem] = useState(null);
 const handleDeleteConfirmation = (item) => {
  setSelectedItem(item); // Set the selected item
  setIsOpenDeleteUserConfirmation(true); // Open the dialog
};

const handleCloseDeleteUserConfirmation=()=>{
  console.log("set is open ",isOpenDeleteUserConfirmation)
  setSelectedItem(null)
  setIsOpenDeleteUserConfirmation(false)

}

  const handlePageChange = (page) => {
    const setPageIndex=page-1
    setCurrentPage(setPageIndex); // Update pageIndex based on selected page
  };

  useEffect(()=>{
    console.log("data from dt3",data)
  })
  const dispatch=useDispatch()
const navigate =useNavigate()
const [isLoading,setIsLoading]=useState(false)
  const handleDeleteEmployee=async(...data)=>{
    setIsLoading(true)
    console.log("payload for delete employee",data[0])
      const payload={
        "user_id":data[0].user_id,
        user_type:data[0].user_type,
        user_email:data[0].user_email
      }
      console.log("payload1 for delete employee",payload)
      try {
        const response=await deleteEmployee(payload)
        console.log("response delete employee",response)
        if(response && response?.code===200 ){
          getAllEmployee()
          dispatch(alertSuccess("Employee Deleted Successfully"))
          setIsOpenDeleteUserConfirmation(false)
          setIsLoading(false)
        }
        else{
          dispatch(alertDanger(response?.message))
          setIsOpenDeleteUserConfirmation(false)
          setIsLoading(false)
        }
      } catch (error) {
        console.log("Error in delete employee api",error)
        dispatch(alertDanger("Error in Delete Employee"))
        setIsOpenDeleteUserConfirmation(false)
        setIsLoading(false)
      }
  }

  const handleDeleteDistributor = async(...data)=>{
    setIsLoading(true)
    console.log("payload for delete distributor",data[0])
    const payload={
      "user_id":data[0].user_id,
      user_type:data[0].user_type,
      user_email:data[0].user_email
    }
    console.log("payload1 for delete distributor",payload)
    try {
      const response=await deleteDistributor(payload)
      console.log("response delete distributor",response)
      if(response && response?.code===200){
        getAllDistributor()
        dispatch(alertSuccess("Distributor Deleted Successfully"))
        setIsOpenDeleteUserConfirmation(false)
        setIsLoading(false)
      }
      else{
        dispatch(alertDanger(response?.message))
        setIsOpenDeleteUserConfirmation(false)
        setIsLoading(false)
      }
    } catch (error) {
      dispatch(alertDanger("Error In Delete Distributor"))
      console.log("Error in delete distributor api",error)
      setIsOpenDeleteUserConfirmation(false)
      setIsLoading(false)
    }
  }

  const handleDeleteInvestor =async(...data)=>{
    setIsLoading(true)
    console.log("payload for delete investor",data[0])
      const payload={
        "user_id":data[0].user_id,
        user_type:data[0].user_type,
        user_email:data[0].user_email
      }
      console.log("payload1 for delete investor",payload)
    try {
      const response=await deleteInvestor(payload)
      console.log("response delete InvestordeleteInvestor",response)
      if(response && response?.code===200){
        getAllInvestor()
        dispatch(alertSuccess("Investor Deleted Successfully"))
        setIsOpenDeleteUserConfirmation(false)
        setIsLoading(false)
      }
      else{
        dispatch(alertDanger(response?.message))
        setIsOpenDeleteUserConfirmation(false)
        setIsLoading(false)
      }
    } catch (error) {
      dispatch(alertDanger("error in Delete Investor"))
      console.log("Error in delete InvestordeleteInvestor api",error)
       setIsOpenDeleteUserConfirmation(false)
      setIsLoading(false)
    }
  }

  const handleDeleteConfirm = async () => {
    if (!selectedItem) return;
  
    if(user_type==="employee")
    {
     return handleDeleteEmployee({user_type:selectedItem?.user_type,user_email:selectedItem?.user_email,user_id:selectedItem?.user_id})
    }
    if(user_type==="distributor"){
      return handleDeleteDistributor({user_type:selectedItem?.user_type,user_email:selectedItem?.user_email,user_id:selectedItem?.user_id})
    }
    if(user_type==="investor"){
      return handleDeleteInvestor({user_type:selectedItem?.user_type,user_email:selectedItem?.user_email,user_id:selectedItem?.user_id})
    }
  
  };

  const handleViewEmployeeInfo=async(...data)=>{
    setIsLoading(true)
    const payload ={
      user_id:data[0].user_id,
      user_type:data[0].user_type,
      user_email:data[0].user_email
    }
    try {
      const response=await getEmployeeInfo(payload)
      console.log("respose for employee info ",response)
      if(response ){
        if(response?.code!==200){
          dispatch(alertDanger("Internal Server Error"))
          setIsLoading(false)
          return
        }
        dispatch(setEmployeeInfo(response?.data))
        const { user_id, action_type } = data[0];
        if(action_type==="View"){
          navigate(`/admin/employee-view-user?user_id=${user_id}&action_type=${action_type}`);
          setIsLoading(false)
           return
          }
        navigate(`/admin/employee-view-user?user_id=${user_id}&action_type=${action_type}`);
        setIsLoading(false)
        return
        
        
      }
      else{
        dispatch(alertDanger("Internal Server Error"))
        setIsLoading(false)
      }
    } catch (error) {
      dispatch(alertDanger("Internal Server Error"))
      console.log("error in view employe info api",error)
      setIsLoading(false)
    }
    // finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
    // }
  }

  const handleViewDistributorInfo = async (...data) => {
    setIsLoading(true)
  
    const payload = {
      user_id: data[0].user_id,
      user_type: data[0].user_type,
      user_email: data[0].user_email,
      action_type: data[0].action_type, // Pass action_type from button options
    };
  
    try {
      const response = await getDistributorInfo(payload);
      console.log("response for distributor info ", response);
  
      if (response  ) {
        if(response?.code!==200){
          dispatch(alertDanger("Internal Server Error"))
          setIsLoading(false)
          return
        }
        dispatch(setDistributorInfo(response?.data));
        const { user_id, action_type } = data[0];
        // Construct the correct URL and navigate
        if(action_type==="View")
        {
          
          // dispatch(loaderSet(false));
           navigate(`/admin/distributor-view-user?user_id=${user_id}&action_type=${action_type}`);
           setIsLoading(false)
           return
          }
         navigate(`/admin/distributor-view-user?user_id=${user_id}&action_type=${action_type}`);
         setIsLoading(false)
         return;
      }
      else{
        dispatch(alertDanger("Internal Server Error"))
        setIsLoading(false)
      }
    } catch (error) {
      dispatch(alertDanger("Internal Server Error"))
      console.log("Error in view distributor info API", error);
      setIsLoading(false)
    }
    // finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
    // }
  };
  

  const handleViewInvestorInfo=async(data,action_type)=>{
    setIsLoading(true)
    const payload ={
      user_id:data.user_id,
      user_type:data.user_type,
      user_email:data.user_email
    }
    try {
      const response=await getInvestorInfo(payload)
      console.log("respose for investor info ",response)
      if (response  ) {
        if(response?.code!==200){
          dispatch(alertDanger("Internal Server Error"))
          setIsLoading(false)
          return
        }

        
        dispatch(setInvestorInfo(response))
        
        // Construct the correct URL and navigate
        const { user_id } = data;
        if(action_type==="View")
       {
         dispatch(loaderSet(false));
         if(isEmployeeLoggedIn){
          // dispatch(setInvestorInfo(data))
          navigate(`/employee/investor-view-user?user_id=${user_id}&action_type=${action_type}`);
          setIsLoading(false)
          return 
        }
         navigate(`/admin/investor-view-user?user_id=${user_id}&action_type=${action_type}`);
         setIsLoading(false)
         return
        }
        if(isEmployeeLoggedIn){
           navigate(`/employee/investor-view-user?user_id=${user_id}&action_type=${action_type}`);
           setIsLoading(false)
           return
          }
        navigate(`/admin/investor-view-user?user_id=${user_id}&&action_type=${action_type}`)
        setIsLoading(false)
        return
      }
      else{
        dispatch(alertDanger("Internal Server Error"))
        setIsLoading(false)
      }
    } catch (error) {
      dispatch(alertDanger("Internal Server Error"))
      console.log("error in view investor info api",error)
      setIsLoading(false)
    }
    // finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
    // }
  }

  


  const columnsValue = [
    {
      investorName: "ABC",
      investedDate: "12-10-2024",
      country: "India",
      investedAmount: 12000,
    },
    {
      investorName: "DCB",
      investedDate: "20-10-2024",
      country: "India",
      investedAmount: 12000,
    },
    {
      investorName: "MNC",
      investedDate: "12-9-2024",
      country: "India",
      investedAmount: 12,
    },
    {
      investorName: "XYZ",
      investedDate: "12-10-2023",
      country: "India",
      investedAmount: 12010,
    },
  ];

  return (
    <>
       {
        isLoading && <Loader/>
      }
      <Table>
        <TableHeader>
      
          <TableRow   >
          {buttonOptions?.length > 0 && (
              <TableHead className="w-[6%] text-left">Actions</TableHead>
            )}
            <TableHead className="" >Sr No.</TableHead>
            {columns?.map((column, index) => (
              <TableHead key={index} className="" >{column.header}</TableHead>
            ))}
            {/* Conditionally render the "Actions" column if buttonOptions are provided */}
            
          </TableRow>
        </TableHeader>
        <TableBody>
          { data && data?.length>0 &&  data?.map((item, rowIndex) => (
            <TableRow className="cursor-default" key={rowIndex} onClick={() => onRowClick(item)}>
               {buttonOptions?.length > 0 && (
                <TableCell className="w-[6%] text-left">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <EllipsisVertical className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      {buttonOptions.map((option, index) => (
                        <div key={index}>
                          <DropdownMenuItem>
                            <Button
                              variant="none"
                              className="flex items-center px-2 gap-4 h-6 text-sm"

                              onClick={()=>{
                                if(user_type==="employee"){
                                   if(option.name==="Delete"){
                                    console.log("item?.user_id ",item?.user_id)
                                    setSelectedItem(item)
                                    return handleDeleteConfirmation(item);
                                    // return handleDeleteEmployee({user_type:item?.user_type,user_email:item?.user_email,user_id:item?.user_id})
                                  }
                                   if (option.name === "View") {
                                    
                                    handleViewEmployeeInfo({
                                      user_type: item?.user_type,
                                      user_id: item?.user_id,
                                      user_email:item?.user_email,
                                      action_type:option.name
                                    });
                                    return;
                                  }
                                  if(option.name==="Edit"){
                                    
                                    handleViewEmployeeInfo({
                                      user_type: item?.user_type,
                                      user_id: item?.user_id,
                                      user_email:item?.user_email,
                                      action_type:option.name
                                    });
                                    return;
                                  }
                                }
                                if(user_type==="distributor"){
                                  if(option.name==="Delete"){
                                    setSelectedItem(item)
                                    return handleDeleteConfirmation(item);
                                    // return handleDeleteDistributor({user_type:item?.user_type,user_email:item?.user_email,user_id:item?.user_id})
                                  }
                                  if(option.name==="View"){
                                    
                                    
                                    return  handleViewDistributorInfo({
                                      user_type: item?.user_type,
                                      user_id: item?.user_id,
                                      user_email:item?.user_email,
                                      action_type:option.name

                                    });
                                      
                                     

                                      
                                  }
                                  if(option.name==="Edit"){
                                   
                                    
                                      handleViewDistributorInfo({
                                        user_type: item?.user_type,
                                        user_id: item?.user_id,
                                        user_email:item?.user_email,
                                        action_type:option.name
                                      })
                                        
                                        return;
                                  }
                                }
                                if(user_type==="investor"){
                                  if(option.name==="Delete"){
                                    // setSelectedItem(item)
                                    return handleDeleteConfirmation(item);
                                   
                                    // return handleDeleteInvestor({user_type:item?.user_type,user_email:item?.user_email,user_id:item?.user_id})
                                  }
                                  if(option.name==="View"){
                                    
                                      return handleViewInvestorInfo(item,option.name);
                                     
                                  }
                                  if(option.name==="Edit"){
                                    
                                    handleViewInvestorInfo(item,option.name)
                                      
                                      return;
                                  }
                                }

                              }}

                            >
                              {option.icon}
                              <span>{option.text}</span>
                            </Button>
                          </DropdownMenuItem>
                          {index < buttonOptions.length - 1 && (
                            <DropdownMenuSeparator />
                          )}
                        </div>
                      ))}
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              )}
              <TableCell>{rowIndex + 1}</TableCell>
              {columns?.map((header, colIndex) => (
                <TableCell key={colIndex} className="flex-grow">
                  {item[header.id]}
                </TableCell>
              ))}
              {/* Conditionally render the action buttons if buttonOptions exist */}
             
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="flex justify-end items-center mt-4">
          
          <div>
                <span>
                  Page{" "}
                  <strong>
                    
                    {currentPage}
                     of{" "}
                    {totalPage}
                  </strong>{" "}
                </span>
                <select
                  value={currentPage+1}
                  onChange={(e) => handlePageChange(Number(e.target.value))}
                  className="p-2 border border-gray-300 rounded ml-2 mb-2"
                >
                 {Array.from({ length: totalPage }, (_, index) => index +1).map((page) => (
                    <option key={page} value={page+1}>
                      Page {page}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                    {/* Dialogue div for Delete User Confirmation  */}

    
      <DialogBox
        isOpen={isOpenDeleteUserConfirmation}
        onClose={handleCloseDeleteUserConfirmation}
        title={`Delete ${user_type} Confirmation`}
        message={`Are you sure you want to delete ${selectedItem?.name}, this ${user_type}? This action cannot be undone.`}
       onConfirm={handleDeleteConfirm}
      />
       </div>
  </div>


       
    </>
  );
};

export default Datatable3;
